
// SVG Icon: ar-hover1
export default { id: "terriajs-ar-hover1" };
export const id = "terriajs-ar-hover1";
export const name = "ar-hover1";
